<script setup lang="ts">
import SeminarCardV2 from '~/components/organisms/SeminarCard/SeminarCardV2.vue';
import { type FragmentType, graphql } from '~/gql';

const props = defineProps<{
  seminars: FragmentType<typeof SeminarFragment>[];
}>();

const SeminarFragment = graphql(`
  fragment SeminarDetailSeminarsSectionSeminar on Seminar {
    id
    ...SeminarCardV2Seminar
  }
`);

const seminars = useComputedFragment(SeminarFragment, () => props.seminars);
</script>

<template>
  <div>
    <h2 :class="$style.container__heading">
      このセミナーを見ている人は<br
        :class="$style.container__newLine"
      />こちらもチェック
    </h2>
    <div :class="$style.container__seminars">
      <SeminarCardV2 v-for="s in seminars" :key="s.id" :seminar="s" />
    </div>
  </div>
</template>

<style module lang="scss">
.container {
  &__heading {
    width: 100%;
    line-height: 1.8;
    font-size: 24px;
    font-weight: bold;

    @include mobile-only {
      text-align: center;
      font-size: 20px;
    }
  }
  &__newLine {
    display: none;

    @include mobile-only {
      display: unset;
    }
  }
  &__seminars {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    gap: 24px;

    @include mobile-only {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
